export function modalOpen() {
    const scrollTopSafari = document.body.scrollTop
    const scrollTopOthers = document.documentElement.scrollTop
    const scrollTop = scrollTopSafari + scrollTopOthers

    document.body.classList.add('modal-open')
    document.body.style.top = -scrollTop + 'px'
}

export function modalClose() {
    document.body.classList.remove('modal-open')
}
